import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'
import Moment from 'moment'

import {ListItem} from 'material-ui/List'

import AttachmentRender from './AttachmentRender'
import AttachmentCard from './Attachments/AttachmentCard'

import dataActions from 'actions/dataActions'
import sectionsActions from 'actions/sections'

import { owners } from '../selectors/entities'
import { doc, makeRefSelector } from '../selectors/common'
import { notificationComment, oldNotificationComment, notificationObject } from '../selectors/notifications'
import { notificationAvatarFrom } from '../selectors/attachments'
import { plainText } from 'utils/commentsText'

let entityMap = {
	"project": "project"
  , "task": "task"
  , "transaction/invoice": "transaction"
  , "transaction/bill": "transaction"
  , "transaction/invoice-payment": "transaction"
  , "property": "property"
  , "lease": "lease"
  , "owner": "owner"
  , "repairman": "repairman"
  , "agent": "agent"
  , "tenant": "tenant"
  , "manager": "manager"
  , "template": "template"
  , "application": "application"
  , "listing": "listing"
  , "term": "term"
  , "merchant": "vendor"
}

let select = (state, props) => ({
	notification: doc(state, props.notificationID)
  , manager: makeRefSelector("from")(state, props.notificationID)
  , comment: notificationComment(state, props.notificationID)
  , object: notificationObject(state, props.notificationID)
  , managerAvatar: notificationAvatarFrom(state, props.notificationID)
  , owners: owners(state)
})

export class NotificationCard extends Component {
	render(){
		let { props } = this
		return(
			<div style={{position: "relative"}}>
				<i
					className="material-icons"
					style={{
						color: 'grey'
					  , right: '14px'
					  , top: "15px"
					  , position: "absolute"
					  , right: "10px"
					  , zIndex: "999999"
					  , cursor: "pointer"
					}}
					onClick={() => {
						props.DOC_UPDATE({
							_id: (props.notification) ?props.notification._id : ""
						  , done: (props.notification && props.notification.done)? false: true
						})
					}}
				>
					done
				</i>
				<Link
					to={'/manager/' + entityMap[props.object.type] + '/' + props.object._id}
					key={`notification-link-${props.notification._id}`}
					onClick={()=>{
						props.DOC_UPDATE({
							_id: props.notification._id
						  , read: true
						})
					}}
					style={{textDecoration: "none"}}
				>
					<ListItem
						primaryText={
							<div style={{display: "flex"}}>
							{(props.manager && props.managerAvatar)?
								<AttachmentCard attachmentID={props.managerAvatar._id} avatar={true} />
								:
								<img
									src={'/' + process.env.REACT_APP_NAME + "/static/img/res/avatar.png"}
									style={{
										width: '32px'
									  , height:'32px'
									  , display: 'inline-block'
									}}
								/>}
								<div style={{marginLeft: "15px", }}>
									<span style={{display: "block", marginBottom: "10px", fontWeight: (!props.notification.read)? "bold" : "normal"}}>
										{(props.manager && props.manager.name)  || (props.notification.from && props.owners[props.notification.from] && props.owners[props.notification.from].firstName) || props.notification.createdBy}
									</span>
									<span style={{display: "block", fontSize: "12px", fontWeight: (!props.notification.read)? "bold" : "normal"}}>
										{
											(props.notification && props.notification.updatedAt)?Moment(props.notification.updatedAt).format("MM/DD/YYYY hh:mm")
											:
											(props.notification && props.notification.createdAt)?Moment(props.notification.createdAt).format("MM/DD/YYYY hh:mm"): ""
										}
									</span>
								</div>
							</div>
						}
						secondaryText={
							<div>
								<p style={{color:  (!props.notification.read) ? "#000" : (0, 0, 0, 0.870588), margin: "0"}}>
									{plainText(props.comment.contents)}
								</p>
							</div>
						}
						style={{
							  fontWeight: (!props.notification.read)? "bold" : "normal"
						}}
						className={`single-item ${(!props.notification.read)? 'unread': ''}`}
						secondaryTextLines={2}
						key={(props.notification) ?props.notification._id : ""}
					/>
				</Link>
			</div>
		)
	}
}

export default connect(select, R.mergeAll([dataActions, sectionsActions]))(NotificationCard)



// WEBPACK FOOTER //
// ./src/components/NotificationCard.js